import PageHeader from './PageHeader';
import PageFooter from './PageFooter';

const BasePage = ({ skill, data }) => {
  return (
    <div id='page'>
      <PageHeader />

      <section className='skill-section'>
        <h1>{skill.title}</h1>
        <p>{skill.description}</p>
        <div className='image'>
          <img src={skill.image} alt={skill.title} />
        </div>
      </section>

      <section className='blogs'>
        <h2>blogs</h2>
        <hr />
        <ul>
          {data.map((blogData, index) => (
            <li key={index}>
              <img
                className='dataImage'
                src={blogData.imagelink}
                alt={blogData.title}
              />
              <div className='description'>
                <h3>{blogData.title}</h3>
                <p>{blogData.description}</p>
                <a href={blogData.blogLink}>もっと見る</a>
              </div>
            </li>
          ))}
        </ul>
      </section>

      <PageFooter />
    </div>
  );
};

export default BasePage;
